// used on the backend
export const FEATURES = {
    ADVANCED_ECOMMERCE: 'advancedEcommerce',
    AFFILIATES: 'affiliateMarketing',
    APPOINTMENTS: 'appointments',
    AUTOMATIONS: 'automations',
    BRANDING_CENTER: 'brandingCenter',
    CAMPAIGN_BUILDER_NAV: 'campaignBuilderNav',
    CHECKOUT_FORM_PROMO_CODES: 'checkoutFormPromoCodes',
    CHECKOUT_FORMS: 'checkoutForms',
    CLASSIC_CAMPAIGN_BUILDER: 'classicCampaignBuilder',
    CLASSIC_CUSTOM_FIELDS: 'classicCustomFields',
    COMPANIES: 'companies',
    CONVRRT_PRO: 'convrrtPro',
    CONTACT_LISTS: 'contactLists',
    DATE_TIME_CUSTOM_FIELDS: 'dateTimeCustomFields',
    EMAIL_BROADCAST: 'emailBroadcast',
    INVOICES: 'invoices',
    LEAD_SCORE: 'leadScore',
    LEAD_SOURCE: 'leadSource',
    LEGACY_APPOINTMENTS: 'legacyAppointments',
    LEGACY_LANDING_PAGES: 'legacyLandingPages',
    LEGACY_OPPORTUNITIES: 'legacyOpportunities',
    LEGACY_SAVED_SEARCHES: 'legacySavedSearches',
    ONBOARDING: 'onboarding',
    ONBOARDING_WIDGET: 'onboardingWidget',
    PAID_APPOINTMENTS: 'paidAppointments',
    PIPELINE: 'pipeline',
    REPORTS: 'reports',
    ROLES_AND_PERMISSIONS: 'rolesAndPermissionsManager',
    SMART_FORMS_EDITING: 'smartFormsEditing',
    SMS_AUTOMATION: 'smsAutomation',
    SMS_BROADCAST: 'smsBroadcast',
    UNLAYER_EMAIL_BUILDER: 'unlayerEmailBuilder',
    UNLAYER_LANDING_PAGE: 'unlayerLandingPage',
    UNLAYER_LANDING_PAGE_MAX: 'unlayerLandingPageMax',
};

export const MISSING_FEATURES = {
    [FEATURES.ADVANCED_ECOMMERCE]: {
        label: 'ContentSharingLib.missingFeatureError.advancedEcommerce',
    },
    [FEATURES.AFFILIATES]: {
        label: 'ContentSharingLib.missingFeatureError.affiliates',
    },
    [FEATURES.APPOINTMENTS]: {
        label: 'ContentSharingLib.missingFeatureError.appointments',
    },
    [FEATURES.AUTOMATIONS]: {
        label: 'ContentSharingLib.missingFeatureError.automations',
    },
    [FEATURES.BRANDING_CENTER]: {
        label: 'ContentSharingLib.missingFeatureError.brandingCenter',
    },
    [FEATURES.CAMPAIGN_BUILDER_NAV]: {
        label: 'ContentSharingLib.missingFeatureError.campaignBuilderNav',
    },
    [FEATURES.CHECKOUT_FORM_PROMO_CODES]: {
        label: 'ContentSharingLib.missingFeatureError.checkoutFormPromoCodes',
    },
    [FEATURES.CHECKOUT_FORMS]: {
        label: 'ContentSharingLib.missingFeatureError.checkoutForms',
    },
    [FEATURES.CLASSIC_CAMPAIGN_BUILDER]: {
        label: 'ContentSharingLib.missingFeatureError.classicCampaignBuilder',
    },
    [FEATURES.CLASSIC_CUSTOM_FIELDS]: {
        label: 'ContentSharingLib.missingFeatureError.classicCustomFields',
    },
    [FEATURES.COMPANIES]: {
        label: 'ContentSharingLib.missingFeatureError.companies',
    },
    [FEATURES.CONVRRT_PRO]: {
        label: 'ContentSharingLib.missingFeatureError.convrrtPro',
    },
    [FEATURES.CONTACT_LISTS]: {
        label: 'ContentSharingLib.missingFeatureError.contactLists',
    },
    [FEATURES.DATE_TIME_CUSTOM_FIELDS]: {
        label: 'ContentSharingLib.missingFeatureError.dateTimeCustomFields',
    },
    [FEATURES.EMAIL_BROADCAST]: {
        label: 'ContentSharingLib.missingFeatureError.emailBroadcast',
    },
    [FEATURES.INVOICES]: {
        label: 'ContentSharingLib.missingFeatureError.invoices',
    },
    [FEATURES.LEAD_SCORE]: {
        label: 'ContentSharingLib.missingFeatureError.leadScore',
    },
    [FEATURES.LEAD_SOURCE]: {
        label: 'ContentSharingLib.missingFeatureError.leadSource',
    },
    [FEATURES.LEGACY_APPOINTMENTS]: {
        label: 'ContentSharingLib.missingFeatureError.legacyAppointments',
    },
    [FEATURES.LEGACY_LANDING_PAGES]: {
        label: 'ContentSharingLib.missingFeatureError.legacyLandingPages',
    },
    [FEATURES.LEGACY_OPPORTUNITIES]: {
        label: 'ContentSharingLib.missingFeatureError.legacyOpportunities',
    },
    [FEATURES.LEGACY_SAVED_SEARCHES]: {
        label: 'ContentSharingLib.missingFeatureError.legacySavedSearches',
    },
    [FEATURES.ONBOARDING]: {
        label: 'ContentSharingLib.missingFeatureError.onboarding',
    },
    [FEATURES.ONBOARDING_WIDGET]: {
        label: 'ContentSharingLib.missingFeatureError.onboardingWidget',
    },
    [FEATURES.PAID_APPOINTMENTS]: {
        label: 'ContentSharingLib.missingFeatureError.paidAppointments',
    },
    [FEATURES.PIPELINE]: {
        label: 'ContentSharingLib.missingFeatureError.pipeline',
    },
    [FEATURES.REPORTS]: {
        label: 'ContentSharingLib.missingFeatureError.reports',
    },
    [FEATURES.ROLES_AND_PERMISSIONS]: {
        label: 'ContentSharingLib.missingFeatureError.rolesAndPermissions',
    },
    [FEATURES.SMART_FORMS_EDITING]: {
        label: 'ContentSharingLib.missingFeatureError.smartFormsEditing',
    },
    [FEATURES.SMS_AUTOMATION]: {
        label: 'ContentSharingLib.missingFeatureError.smsAutomation',
    },
    [FEATURES.SMS_BROADCAST]: {
        label: 'ContentSharingLib.missingFeatureError.smsBroadcast',
    },
    [FEATURES.UNLAYER_EMAIL_BUILDER]: {
        label: 'ContentSharingLib.missingFeatureError.unlayerEmailBuilder',
    },
    [FEATURES.UNLAYER_LANDING_PAGE]: {
        label: 'ContentSharingLib.missingFeatureError.unlayerLandingPage',
    },
    [FEATURES.UNLAYER_LANDING_PAGE_MAX]: {
        label: 'ContentSharingLib.missingFeatureError.unlayerLandingPageMax',
    },
};

// these are values from the backend
export const EDITION_TYPES = {
    MAX: 'Max',
    PRO: 'Pro',
    ULTIMATE: 'MaxClassic',
    FREE_TRIAL: 'FreeTrial',
    ALL: 'All',
};

// List of all editions (excluding ALL which is a special case)
export const ALL_EDITIONS = [EDITION_TYPES.ULTIMATE, EDITION_TYPES.MAX, EDITION_TYPES.PRO, EDITION_TYPES.FREE_TRIAL];

// these are strings from account services
export const EDITION_STRINGS = {
    MAX: 'Keap Max Edition',
    PRO: 'Keap Pro Edition',
    ULTIMATE: 'Keap Max Classic Edition',
    FREE_TRIAL: 'Keap Free Edition',
    PRO_FREE_TRIAL: 'Keap Pro Free Trial',
};

const EDITION_DEFINITIONS = {
    MAX: {
        label: 'ContentSharingLib.editions.max',
        editionLabel: 'ContentSharingLib.editions.max.edition',
        shortLabel: 'ContentSharingLib.editions.max',
    },
    PRO: {
        label: 'ContentSharingLib.editions.pro',
        editionLabel: 'ContentSharingLib.editions.pro.edition',
        shortLabel: 'ContentSharingLib.editions.pro',
    },
    ULTIMATE: {
        label: 'ContentSharingLib.editions.ultimate',
        editionLabel: 'ContentSharingLib.editions.ultimate.edition',
        shortLabel: 'ContentSharingLib.editions.ultimate.short',
    },
    FREE_TRIAL: {
        label: 'ContentSharingLib.editions.freeTrial',
        editionLabel: 'ContentSharingLib.editions.freeTrial.edition',
        shortLabel: 'ContentSharingLib.editions.freeTrial.short',
    },
    ALL: {
        label: 'ContentSharingLib.editions.all',
        editionLabel: 'ContentSharingLib.editions.all',
        shortLabel: 'ContentSharingLib.editions.all',
    },
};

const EDITION_KEY_MAP = {
    [EDITION_TYPES.MAX]: 'MAX',
    [EDITION_TYPES.PRO]: 'PRO',
    [EDITION_TYPES.ULTIMATE]: 'ULTIMATE',
    [EDITION_TYPES.FREE_TRIAL]: 'FREE_TRIAL',
    [EDITION_TYPES.ALL]: 'ALL',
    [EDITION_STRINGS.MAX]: 'MAX',
    [EDITION_STRINGS.PRO]: 'PRO',
    [EDITION_STRINGS.ULTIMATE]: 'ULTIMATE',
    [EDITION_STRINGS.FREE_TRIAL]: 'FREE_TRIAL',
    [EDITION_STRINGS.PRO_FREE_TRIAL]: 'FREE_TRIAL',
};

export const getEdition = (identifier) => {
    const editionKey = EDITION_KEY_MAP[identifier];

    return editionKey ? EDITION_DEFINITIONS[editionKey] : null;
};

export const EDITIONS = Object.keys(EDITION_KEY_MAP).reduce((acc, key) => {
    acc[key] = getEdition(key);

    return acc;
}, {});
